// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"8cdd3039","421":"d7ce73b3","508":"cb8819e2","719":"8e1894a1","722":"e99b041d","731":"6a60837e","734":"eb8db2b9","742":"cd7cba00","766":"c7d0eb70"}[chunkId] + ".chunk.js";
};